<app-header></app-header>
<div class="content-wrapper my-5 p-t-25 dis-flex">
  <div *ngIf="isSidebarOpen" class="sidebar">
    <app-sidebar
      (close)="toggleSidebar()"
      (homeSelection)="onDropdownSelection($event)"
      [isHomeSidebar]="true"
      [businessThemeLists]="businessThemeLists"
      [quarterShow]="true"
      [groupShow]="true"
      [quarter]="quarter"
    ></app-sidebar>
  </div>

  <div class="main-content p-t-20">
    <div class="container-fluid">
      <div>
        <h1 class="m-b-0">
          Welcome, <span class="text-bold">{{ userData?.data?.name }}</span
          >!
        </h1>

        <div class="body-card pos-relative">
          <!-- <app-loader *ngIf="isLoading"></app-loader> -->
          <div class="dis-flex flex-m flex-sb w-full">
            <h3 class="font-medium m-b-0" *ngIf="this.category != 'affiliate'" [ngbTooltip]="'Short Term Outcomes'">STO</h3>
            <h3 class="font-medium m-b-0" *ngIf="this.category == 'affiliate'" ngbTooltip="Medium Term Outcomes">MTO </h3>
            <div>
              <button class="btn outline b2 wd-120px" (click)="toggleSidebar()">
                <ng-icon
                  name="hugeFilter"
                  size="16"
                  class="m-r-5 lh-1-0 text-70"
                ></ng-icon>
                Filters
                {{ filterCount > 0 ? "(" + filterCount + ")" : "" }}
              </button>
            </div>
          </div>
          <p-divider class="horizontal-divider" />

          <div class="w-full" >
            <div class="float-l wd-22" *ngIf="!isStatusCountLoad">
              <app-total-count-card
                (click)="
                    totalCount == 0
                      ? showAlert()
                      : showOutcomes('Total Outcomes', 'All')
                  "
                title="All"
                [total]="totalCount"
              ></app-total-count-card>
            </div>

            <div class="dis-flex flex-w float-l wd-78" *ngIf="!isStatusCountLoad;else shimmerEffect">
              <div
                *ngFor="
                  let status of (statusCard  | wpDashboardCount:statusCardCount)
                "
                class="wd-20"
              >
                <app-status-card
                  [title]="status.title"
                  [count]="status.count"
                  [iconName]="status.iconName"
                  [iconColor]="status.iconColor"
                  [iconBoxColor]="status.iconBoxColor"
                  class="dis-flex"
                  (click)="
                    status.count == '0'
                      ? showAlert()
                      : showOutcomes('Total Outcomes', status.title)
                  "
                >
                  ></app-status-card
                >
              </div>
            </div>
          </div>
          <ng-container *ngIf="!isStatusCountLoad">
          <h3 class="font-medium m-b-0 m-t-20">Top Views</h3>
          <p-divider class="horizontal-divider" />

          <div class="w-full dis-flex flex-w" >
            <div *ngFor="let dbCard of dashboardCard">
              <app-dashboard-card
                [title]="dbCard.title"
                [iconName]="dbCard.iconName"
                [iconPath]="dbCard.iconPath"
                [iconColor]="dbCard.iconColor"
                [bgColor]="dbCard.bgColor"
                [vectorPath]="dbCard.vectorPath"
                (click)="loadDashboard(dbCard.title)"
              ></app-dashboard-card>
            </div>
          </div>
        </ng-container>
        </div>
      </div>

      <app-quick-action></app-quick-action>
    </div>
  </div>
</div>

<ng-template #shimmerEffect>
  <app-shimmer-list [count]="4"></app-shimmer-list>
</ng-template>
